import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';
import {KeycloakService} from 'keycloak-angular';
import {EmisionCfeService} from '../../services/emision-cfe.service';
import {EmisorCFEDTO} from '../../../models/dtos/EmisorCFEDTO';
import {ConfiguracionInicialDTO} from '../../../models/dtos/ConfiguracionInicialDTO';
import {ActivatedRoute} from '@angular/router';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {SuccessComponent} from '../../popups/success/success.component';
import {VersionComponent} from '../../popups/version/version.component';
import {DetalleCfeComponent} from '../../popups/detalle-cfe/detalle-cfe.component';

@Component
({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.scss']
})
export class MainContainerComponent implements OnInit
{
  emisorCFEDTO: EmisorCFEDTO;
  existeEmisorCFEParaElUsuario: boolean;
  mostrarMenu: boolean;

  constructor(private keycloakService: KeycloakService, private emisionCfeService: EmisionCfeService, private route: ActivatedRoute, private matDialog: MatDialog)
  {

  }

  ngOnInit()
  {
    this.emisorCFEDTO = null;
    this.existeEmisorCFEParaElUsuario = false;
    this.mostrarMenu = false;

    this.emisionCfeService.cambioEnEmisorCFEDTO.subscribe(emisorCFEDTO =>
    {
      this.emisorCFEDTO = emisorCFEDTO;
      this.existeEmisorCFEParaElUsuario = true;
      this.mostrarMenu = true;
    });

    this.cargarConfiguracionInicial();
  }

  public logout(): void
  {
    this.keycloakService.logout(environment.logoutUrl);
  }

  public showVersion() {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    matDialogConfig.minHeight = '10px';
    matDialogConfig.minWidth = '450px';
    matDialogConfig.maxWidth = '700px';
    matDialogConfig.disableClose = false;

    const infoMatDialogRef = this.matDialog.open(VersionComponent, matDialogConfig);
    infoMatDialogRef.afterClosed().subscribe(detalleCFENuevoDTO => { });
  }

  private cargarConfiguracionInicial(): void
  {
    this.emisionCfeService.obtenerConfiguracionInicial().subscribe(
      (configuracionInicialDTO: ConfiguracionInicialDTO) =>
      {
        this.emisionCfeService.setConfiguracionInicialDTO(configuracionInicialDTO);
      },
      (exception: any) =>
      {
        throw exception;
      },
      () =>
      {

      }
    );
  }
}
